import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getOrganizacionesComercial } from '../../api/client'
import { opcionesSuperior, rutaSuperior } from './organizacionesLogica'
import ComercialBuscador from './ComercialBuscador'

// An active organization by typing its name; each option shows where it hangs
// ("CODELCO › División El Teniente"). For an organization's superior it leaves
// out the organization itself and its descendants (excluir: the one edited).
// Contacts' links (E6) pick their organization with it too, leaving out the
// ones the contact already has (excluirIds: one link per organization).
//   value: an organization id or null; onChange(id | null)
export default function ComercialSelectorOrganizacion({ value, onChange, excluir, excluirIds, placeholder, textoVacio, ...resto }) {
  const { t } = useTranslation('comercial')
  const [lista, setLista] = useState(null)
  useEffect(() => {
    let vivo = true
    getOrganizacionesComercial({ archivadas: 'no' }).then(d => vivo && setLista(d)).catch(() => vivo && setLista([]))
    return () => { vivo = false }
  }, [])
  const opciones = useMemo(() => {
    const fuera = new Set(excluirIds || [])
    const elegibles = opcionesSuperior(lista || [], excluir).filter(o => !fuera.has(o.id))
    // The current value stays shown even if it is no longer eligible (e.g. archived since).
    const actual = value != null && !elegibles.some(o => o.id === value) && (lista || []).find(o => o.id === value)
    return [...(actual ? [actual] : []), ...elegibles]
      .map(o => ({ value: o.id, label: o.nombre_comercial, detalle: rutaSuperior(o) || undefined }))
  }, [lista, excluir, excluirIds, value])
  return (
    <ComercialBuscador opciones={opciones} value={value ?? null} onChange={onChange}
      placeholder={lista ? (placeholder ?? t('form.superiorPlaceholder')) : t('panel.cargando')}
      textoVacio={textoVacio} sinCoincidencias={t('form.sinCoincidencias')} {...resto} />
  )
}
